import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppThunkDispatch } from 'state/store';
import { Checkbox } from '@getsynapse/design-system';
import {
  toggleSelectAllProjects,
  selectAreAllProjectsSelected,
  selectAreProjectsPartiallySelected,
} from 'state/ProjectsList/export/exportSlice';
import { selectIsProjectsListEmpty } from 'state/ProjectsList/projectsListSlice';

const SelectAllProjects = () => {
  const dispatch = useAppThunkDispatch();
  const areAllProjectsSelected = useSelector(selectAreAllProjectsSelected);
  const areProjectsPartiallySelected = useSelector(
    selectAreProjectsPartiallySelected
  );
  const isProjectsListEmpty = useSelector(selectIsProjectsListEmpty);
  const checked = areProjectsPartiallySelected
    ? 'mixed'
    : areAllProjectsSelected && !isProjectsListEmpty;

  const handleSelectAllProjects = useCallback(() => {
    dispatch(toggleSelectAllProjects());
  }, [dispatch]);

  return (
    <Checkbox
      checked={checked}
      onChange={handleSelectAllProjects}
      label=''
      disabled={isProjectsListEmpty}
      inputProps={{
        'aria-label': 'select-all-projects-checkbox',
      }}
    />
  );
};

export default SelectAllProjects;
